export default __webpack_public_path__ + "22109655b737f84e89926ff9528d6917.png";